// ─────────────────────────────────────────────
// KLOTHIQ — Supabase Client Factory
// ─────────────────────────────────────────────
// Creates a typed Supabase client instance.
// The actual client instance is created in the web/mobile apps
// using their environment variables.

import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { createAccessFetch } from './access-fetch';

export type KlothiqSupabaseClient = SupabaseClient;

/**
 * Creates a Supabase client instance.
 * Call this from your app's entry point with env vars.
 */
export function createKlothiqClient(
  supabaseUrl: string,
  supabaseAnonKey: string,
): KlothiqSupabaseClient {
  return createClient(supabaseUrl, supabaseAnonKey, {
    global: { fetch: createAccessFetch() },
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
    },
    db: {
      schema: 'public',
    },
  });
}
